export default "__VITE_ASSET__DRDjsgTA__"